import * as React from 'react'

function SvgEe(props) {
	return (
		<svg viewBox="0 0 33 21" width="1em" height="1em" {...props}>
			<path fill="#FFF" d="M0 0h33v21H0z" />
			<path d="M0 0h33v14H0z" />
			<path fill="#4891D9" d="M0 0h33v7H0z" />
		</svg>
	)
}

export default SvgEe
